import BetMan from './Betman';

function App() {
  return <BetMan />;
}

export default App;
